import { useLocation } from 'react-router';

import { ROUTES } from '../utils/common';
import { useNavigate } from './use-navigate';

export const EXCHANGE_BLOCK_ID = 'exchange-calculator';

const scrollToExchange = () => {
  document
    .querySelector(`#${EXCHANGE_BLOCK_ID}`)
    ?.scrollIntoView({ behavior: 'smooth' });
};

export const useExchangeNavigation = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleGoToExchange = async () => {
    if (pathname !== ROUTES.ROOT) {
      await navigate(ROUTES.ROOT);
      setTimeout(scrollToExchange, 500);
    } else {
      scrollToExchange();
    }
  };

  return {
    handleGoToExchange,
  };
};
